;(function () {
	window.__lEventRevealActive = true

	let eventRevealObserver = null

	function initEventKlaviyoForms(root) {
		;(root || document)
			.querySelectorAll('[data-event-klaviyo-form]:not([data-event-klaviyo-bound])')
			.forEach(function (form) {
				form.dataset.eventKlaviyoBound = 'true'
				syncEventKlaviyoState(form)
				form.addEventListener('submit', handleEventKlaviyoSubmit)
			})
	}

	function isEventKlaviyoReady(form) {
		return Boolean(String(form.dataset.companyId || '').trim())
	}

	function syncEventKlaviyoState(form) {
		const submit = form.querySelector('[type="submit"]')
		const isReady = isEventKlaviyoReady(form)

		form.dataset.klaviyoReady = isReady ? 'true' : 'false'

		if (!submit) return

		submit.disabled = !isReady
		submit.setAttribute('aria-disabled', isReady ? 'false' : 'true')
	}

	function setStatus(form, message, isError) {
		const status = form.querySelector('[data-event-form-status]')
		if (!status) return

		status.textContent = message || ''
		status.classList.toggle('is-visible', Boolean(message))
		status.setAttribute('role', isError ? 'alert' : 'status')
	}

	function splitName(value) {
		const parts = (value || '').trim().split(/\s+/).filter(Boolean)

		return {
			firstName: parts[0] || '',
			lastName: parts.length > 1 ? parts.slice(1).join(' ') : '',
		}
	}

	function buildProfile(form) {
		const data = new FormData(form)
		const name = String(data.get('name') || '').trim()
		const email = String(data.get('email') || '').trim()
		const phone = String(data.get('phone') || '').trim()
		const company = String(data.get('company') || '').trim()
		const eventDate = String(data.get('event_date') || '').trim()
		const guestCount = String(data.get('guest_count') || '').trim()
		const message = String(data.get('message') || '').trim()
		const marketingConsent = data.get('marketing_consent') === 'true'
		const names = splitName(name)
		const properties = {
			source: form.dataset.source || 'Event inquiry page',
			form_id: form.dataset.formId || '',
			inquiry_type: 'Event inquiry',
			name: name,
			phone_number: phone,
			company: company,
			event_date: eventDate,
			guest_count: guestCount,
			message: message,
			accepts_marketing: marketingConsent,
		}
		const attributes = {
			email: email,
			properties: properties,
		}

		if (names.firstName) attributes.first_name = names.firstName
		if (names.lastName) attributes.last_name = names.lastName

		Object.keys(properties).forEach(function (key) {
			if (properties[key] === '' || properties[key] === null || properties[key] === undefined) delete properties[key]
		})

		return attributes
	}

	function getKlaviyoError(responseBody) {
		if (responseBody && Array.isArray(responseBody.errors) && responseBody.errors[0]) {
			return responseBody.errors[0].detail || responseBody.errors[0].title
		}

		return ''
	}

	// Opt-in subscribe: only called when the consent checkbox is shown AND ticked and a list is configured.
	function subscribeEventKlaviyoList(companyId, revision, listId, email) {
		const payload = {
			data: {
				type: 'subscription',
				attributes: {
					profile: {
						data: {
							type: 'profile',
							attributes: {
								email: email,
								subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
							},
						},
					},
				},
				relationships: { list: { data: { type: 'list', id: listId } } },
			},
		}

		return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
			method: 'POST',
			headers: {
				accept: 'application/vnd.api+json',
				'content-type': 'application/vnd.api+json',
				revision: revision,
			},
			body: JSON.stringify(payload),
		})
	}

	async function handleEventKlaviyoSubmit(event) {
		event.preventDefault()

		const form = event.currentTarget
		const companyId = String(form.dataset.companyId || '').trim()
		const revision = form.dataset.revision || '2026-04-15'
		const submit = form.querySelector('[type="submit"]')
		const successMessage = form.dataset.successMessage || 'Thank you. Our Events team will be in touch.'
		const errorMessage = form.dataset.errorMessage || 'Please try again or contact us directly.'

		setStatus(form, '', false)
		syncEventKlaviyoState(form)

		if (!form.reportValidity()) return

		if (!isEventKlaviyoReady(form)) {
			setStatus(form, 'Klaviyo settings are missing for this form.', true)

			return
		}

		const profile = buildProfile(form)
		const listId = String(form.dataset.listId || '').trim()
		const consented = Boolean(profile.properties && profile.properties.accepts_marketing)
		const payload = {
			data: {
				type: 'profile',
				attributes: profile,
			},
		}

		if (submit) submit.disabled = true

		try {
			const response = await fetch(
				'https://a.klaviyo.com/client/profiles?company_id=' + encodeURIComponent(companyId),
				{
					method: 'POST',
					headers: {
						accept: 'application/vnd.api+json',
						'content-type': 'application/vnd.api+json',
						revision: revision,
					},
					body: JSON.stringify(payload),
				}
			)
			let body = null

			try {
				body = await response.json()
			} catch (error) {
				body = null
			}

			if (!response.ok) {
				throw new Error(getKlaviyoError(body) || errorMessage)
			}

			if (consented && listId) {
				try {
					await subscribeEventKlaviyoList(companyId, revision, listId, profile.email)
				} catch (subscribeError) {
					// Lead is already captured; list subscription is best-effort and must not fail the inquiry.
				}
			}

			form.reset()
			setStatus(form, successMessage, false)
		} catch (error) {
			setStatus(form, error && error.message ? error.message : errorMessage, true)
		} finally {
			if (submit) submit.disabled = !isEventKlaviyoReady(form)
		}
	}

	function initEventReveals(root) {
		const els = getRevealTargets(root, ':not(.is-revealed)')
		const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

		if (!els.length) {
			if (!document.querySelector('[data-l-event-reveal]:not(.is-revealed)')) {
				document.documentElement.classList.remove('l-event-reveal-prep')
			}

			return
		}

		if (prefersReducedMotion || !window.gsap || !window.IntersectionObserver) {
			revealEventStatic(root)

			return
		}

		if (eventRevealObserver) eventRevealObserver.disconnect()

		eventRevealObserver = new IntersectionObserver(handleEventRevealEntries, {
			root: null,
			rootMargin: '0px 0px -16% 0px',
			threshold: 0.01,
		})

		els.forEach(function (el) {
			el.classList.add('is-reveal-bound')
			eventRevealObserver.observe(el)
		})
	}

	function getRevealScope(root) {
		if (root && root.querySelectorAll) return root

		return document
	}

	function getRevealTargets(root, suffix) {
		const scope = getRevealScope(root)
		const selector = '[data-l-event-reveal]' + (suffix || '')
		const els = Array.from(scope.querySelectorAll(selector))

		if (scope.matches && scope.matches(selector)) {
			els.unshift(scope)
		}

		return els
	}

	function handleEventRevealEntries(entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return

			eventRevealObserver.unobserve(entry.target)
			try {
				playEventReveal(entry.target)
			} catch (error) {
				markEventRevealComplete(entry.target)
			}
		})
	}

	function playEventReveal(el) {
		if (el.classList.contains('is-revealed') || el.classList.contains('is-revealing')) return

		const config = getEventRevealConfig(el)
		const parts = getEventRevealParts(el)
		const media = getEventRevealMedia(el)
		const animatedTargets = [el].concat(parts, media)
		const tl = window.gsap.timeline({
			defaults: {
				ease: 'power3.out',
				overwrite: 'auto',
			},
			onComplete: function () {
				markEventRevealComplete(el)
				window.gsap.set(animatedTargets.length ? animatedTargets : el, {
					clearProps: 'opacity,visibility,transform,willChange',
				})
			},
		})

		el.classList.add('is-revealing')
		window.gsap.set(animatedTargets.length ? animatedTargets : el, { willChange: 'transform,opacity' })

		tl.fromTo(el, getEventRevealFrom(config.shell), getEventRevealTo(config.shell), 0)

		if (parts.length) {
			tl.fromTo(parts, getEventRevealFrom(config.parts), getEventRevealTo(config.parts), 0.08)
		}

		if (media.length) {
			tl.fromTo(media, getEventRevealFrom(config.media), getEventRevealTo(config.media), config.mediaAt)
		}
	}

	function markEventRevealComplete(el) {
		el.classList.remove('is-reveal-bound')
		el.classList.remove('is-revealing')
		el.classList.add('is-revealed')

		if (!document.querySelector('[data-l-event-reveal]:not(.is-revealed)')) {
			document.documentElement.classList.remove('l-event-reveal-prep')
		}
	}

	function revealEventStatic(root) {
		document.documentElement.classList.remove('l-event-reveal-prep')
		getRevealTargets(root).forEach(function (el) {
			markEventRevealComplete(el)
		})
	}

	function getEventRevealFrom(vars) {
		const from = {}

		copyEventRevealProp(vars, from, 'scale')
		copyEventRevealProp(vars, from, 'transformOrigin')
		copyEventRevealProp(vars, from, 'x')
		copyEventRevealProp(vars, from, 'y')

		if (vars.opacity !== undefined) from.autoAlpha = vars.opacity

		return from
	}

	function getEventRevealTo(vars) {
		const to = {}

		copyEventRevealProp(vars, to, 'duration')
		copyEventRevealProp(vars, to, 'ease')
		copyEventRevealProp(vars, to, 'stagger')
		copyEventRevealProp(vars, to, 'transformOrigin')

		if (vars.opacity !== undefined) to.autoAlpha = 1
		if (vars.scale !== undefined) to.scale = 1
		if (vars.x !== undefined) to.x = 0
		if (vars.y !== undefined) to.y = 0

		return to
	}

	function copyEventRevealProp(source, target, prop) {
		if (source[prop] !== undefined) {
			target[prop] = source[prop]
		}
	}

	function getEventRevealConfig(el) {
		const config = {
			shell: {
				opacity: 0,
				y: 16,
				duration: 0.65,
				ease: 'power2.out',
			},
			parts: {
				opacity: 0,
				y: 22,
				scale: 0.99,
				duration: 0.72,
				stagger: { each: 0.055, from: 'start' },
			},
			media: {
				scale: 1.035,
				duration: 1,
				ease: 'power2.out',
				transformOrigin: '50% 55%',
			},
			mediaAt: 0,
		}

		if (el.classList.contains('l-event-hero__inner')) {
			config.shell = {
				opacity: 0,
				scale: 0.985,
				duration: 0.75,
				ease: 'power2.out',
			}
			config.parts = {
				opacity: 0,
				y: -10,
				scale: 0.985,
				duration: 0.85,
				stagger: 0.06,
				transformOrigin: '50% 50%',
			}
			config.media.scale = 1.04
			config.media.duration = 1.2
		} else if (el.classList.contains('l-event-contact__inner')) {
			config.parts = {
				opacity: 0,
				x: function (index, node) {
					return node.classList.contains('l-event-contact__media') ? 14 : 0
				},
				y: function (index, node) {
					return node.classList.contains('l-event-field') ? 10 : 0
				},
				scale: 0.99,
				duration: 0.74,
				stagger: { each: 0.045, from: 'start' },
			}
		}

		return config
	}

	function getEventRevealParts(el) {
		let selector

		if (el.classList.contains('l-event-hero__inner')) {
			selector = '.l-event-hero__title, .l-event-hero__cta'
		} else if (el.classList.contains('l-event-contact__inner')) {
			selector = '.l-event-contact__heading, .l-event-field, .l-event-contact__submit, .l-event-contact__media'
		} else if (el.classList.contains('l-event-reservation__inner')) {
			selector =
				'.l-event-reservation__logo, .l-event-reservation__heading, .l-event-reservation__address, .l-event-reservation__brand'
		}

		return selector ? getVisibleNodes(el.querySelectorAll(selector)) : []
	}

	function getEventRevealMedia(el) {
		return getVisibleNodes(
			el.querySelectorAll(
				'.l-event-hero__img, .l-event-contact__img, .l-event-reservation__logo img, .l-event-reservation__brand img'
			)
		)
	}

	function getVisibleNodes(nodes) {
		const seen = []

		return Array.prototype.filter.call(nodes, function (node) {
			if (!node || seen.indexOf(node) !== -1 || !node.getClientRects().length) return false
			seen.push(node)

			return true
		})
	}

	function initEventPage(root) {
		initEventKlaviyoForms(root)
		initEventReveals(root)
	}

	function safeInitEventPage(root) {
		try {
			initEventPage(root)
		} catch (error) {
			revealEventStatic(root)
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			safeInitEventPage(document)
		})
	} else {
		safeInitEventPage(document)
	}

	if (window.Shopify && window.Shopify.designMode) {
		document.addEventListener('shopify:section:load', function (event) {
			safeInitEventPage(event.target)
		})
	}
})()
